import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestDropdown, {
  DropdownProps,
} from 'ext-ui/design-system/generated/latest/components/Dropdown/Dropdown'
import GeneratedLiveDropdown from 'ext-ui/design-system/generated/live/components/Dropdown/Dropdown'
import React, { ReactElement } from 'react'

function renderDesignSystemDropdown(
  Component: typeof GeneratedLiveDropdown,
  channel: 'live' | 'latest',
  props: DropdownProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveDropdown(props: DropdownProps): ReactElement {
  return renderDesignSystemDropdown(GeneratedLiveDropdown, 'live', props)
}

function LatestDropdown(props: DropdownProps): ReactElement {
  return renderDesignSystemDropdown(GeneratedLatestDropdown, 'latest', props)
}

function Dropdown(props: DropdownProps): ReactElement {
  const ResolvedDropdown = useResolvedDesignSystemComponent(
    LiveDropdown,
    LatestDropdown,
  )

  return <ResolvedDropdown {...props} />
}

export default Dropdown
export type { DropdownProps }
